import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, Inject, Injectable, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import {LayoutModule} from './modules/layout/layout.module';
import { ServiceService } from './service.service';
// car Transfer


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      deps: [ServiceService],
      useFactory: appInitializerFactory,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function appInitializerFactory(ServiceService: ServiceService): Function {
  return () => ServiceService.loadConfig();
};





